

<form class="form-signin text-center">
  <div>
    <img class="mb-4" src="assets/images/JT_signin_Logo.gif" alt="Jobtrain Login" width="200">
  </div>
  {{'Common.ResetyourPassword' | translate}}
  <br />
  <h1 class="h3 mb-3 font-weight-normal">{{ 'Login.Verify' | translate }}</h1>
  <h1 class="h3 mb-3 font-weight-normal">{{ 'Login.SecurityCode' | translate }}</h1>


  <label for="inputPassword" class="sr-only">{{ 'Login.InputPassword' | translate }}</label>
  <app-password-input [(ngModel)]="user.password"
    name="password"
    [placeholder]="'Password'"
    [maxlength]="25"
    required
    (byKeyup)="checkIfMatchingPasswords($event)"
    className="password-icon"
    data-test-id="txt-password">
  </app-password-input>

  <app-password-input [(ngModel)]="user.confirmPassword"
    name="confirmPassword"
    [placeholder]="'Re-type Password'"
    required
    (byKeyup)="checkIfMatchingPasswords($event)"
    className="password-icon"
    data-test-id="txt-confirm-password">
  </app-password-input>

  <div class="text-left">
    @if (submittedApplicationForm && notEquivalent ) {
      <label class="text-danger">{{'Common.Passworddoesnotmatch' | translate}}</label>
    }
  </div>
  <div class="text-left">
    @if (isPasswordBreached) {
      <div>
        <app-pwned-password-instructions></app-pwned-password-instructions>
      </div>
    }
  </div>
  <button class="btn btn-lg btn-primary btn-block btn_submit " type="submit" (click)="ChangePassword()">{{ 'Login.Submit' | translate }}</button>
  <br />
  <div class="password-strength">
    @if (user.password) {
      <password-strength-meter [password]="user.password"
        (strengthChange)="strengthChanged()">
      </password-strength-meter>
    }
  </div>
  <label class="text-danger text-left">{{common.message}}</label>

  <br />
  <br />
  <p class="text-muted">&copy; {{ 'Login.Footer' | translate }}</p>
</form>










